import Fellowships from "./Fellowships";
import Leaderboard from "./Leaderboard";
import type { Units } from "../lib/format";

export default function FellowshipScreen({ units, userId, onChanged }: { units: Units; userId: string; onChanged?: () => void }) {
  return (
    <div className="screen" aria-label="Fellowship">
      <div className="screen-inner">
        <h1 className="h1">Fellowship</h1>
        <div className="sub">Walk with friends, and see who is furthest down the road.</div>
        <h2 className="h2" style={{ marginTop: 22 }}>Your fellowships</h2>
        <Fellowships units={units} userId={userId} onChanged={onChanged} />
        <h2 className="h2">Leaderboard</h2>
        <Leaderboard units={units} userId={userId} />
      </div>
    </div>
  );
}
